/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable import/extensions */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import NavRoutes from './routes';
import { ToastContainer } from 'react-toastify';
import './App.css';
import { getCompanyProfileData, getDealData, getUserSession } from './redux/UserSessionSlice';
import { processCognitoUserData } from './utils/companyDataUtils';
import { useDispatch, useSelector } from 'react-redux';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { io } from 'socket.io-client';
import { CallContext, HamburgerContext, LanguageContext, NewsFeedContext } from './libs/Context';
import { Auth, Hub } from 'aws-amplify';
import ConnectionLost from './libs/ConnectionLost';
import { getCompaniesData, getUserData, userVisits } from './containers/actions/admin_actions';
import { chatUnreadCount } from './containers/actions/chat_actions';
import GlobalLoader from './components/Common/Loaders/GlobalLoader/index';
import FileUploadBox from './UiComponents/FileUploadBox';
import { generateRandomUUID, getObjectWithLanguage, getSocketSessionId, isInlynkGroupMissing } from './libs/HelperContent';
import { getConnectionCount } from './containers/actions/new_connections_action';
import { updateBadgeCount } from './redux/NetworkRedux';
// import { ChatProvider } from './components/Common/GlobalChat/Components/ChatContext';
// import ChatBox from './components/Common/GlobalChat';
// import { getFeedConfig } from './containers/actions/feeds_actions_new';
import useGetConfigs from './libs/useGetConfigs';
import useFirebase, { firebaseDB } from './utils/Firebase/useFirebase';
import { PRESENCE_ENUMS } from './libs/enums/presenceEnums';
import { dbListener, DeletedMsgDbListener, listenToUserStatus, MsgDbListener, calldbListener, listenToSubcollectionChanges } from './utils/Firebase/firebaseQuery';
import { updateDeviceData } from './utils/CollaborationUtils';
import { getMessagesFromLocalDbPagination, checkDatabaseHealth, resetDatabaseConnection, checkAndClearIndexedDBIfUserMismatch, requestPersistentStorage } from './utils/LocalDB';
import { setChatMessages, setGroupIds, setCurrentUserSettings } from './redux/PresenceRedux';
import { orderBy, where } from 'firebase/firestore';
import useMessageHook from './containers/CollaborationRevised/customHooks/useMessageHook';
import AudioCalls from './containers/CollaborationRevised/Components/MainPart/Components/CallScreens/AudioCalls';
import { store } from './redux/store';
import useCallHelper from './libs/CallHelper';
import PeerToPeerCall from './containers/CollaborationRevised/Components/MainPart/Components/CallScreens/VideoCalls/Components/PeerToPeerCall';
import GroupCallPresence from './containers/CollaborationRevised/Components/MainPart/Components/CallScreens/GroupCallPresence';
import { fetchUncategorizedIdAsync } from './redux/ResourceRedux';
import AudioPlayer from './containers/ResourcesRevised/Components/ContentView/Podcastview/Components/AudioPlayer';
import deviceInfo from './libs/BrowserDevices';

let theme = createTheme({
	palette : {
	  primary : {
			main : '#24a4c4'
	  },
	  secondary : {
			main : '#FF9D29'
	  }
	},
	typography : {
		fontFamily :
		'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif'
	},
	components : {
	  MuiDialog : {
			styleOverrides : {
		  paper : {
					borderRadius : '13px'
		  }
			}
	  },
	  MuiMenu : {
			styleOverrides : {
				paper : {
					borderRadius : '13px'
				}
			}
		},
	  MuiCard : {
			styleOverrides : {
		  root : {
					borderRadius : '13px'
		  }
			} },
	  MuiPaper : {
			styleOverrides : {
		  root : {
					borderRadius        : '13px',
					'&.MuiDrawer-paper' : {
						borderRadius : '0px'
					}
		  }
			}
	  },
		MuiTableContainer : {
			styleOverrides : {
		  root : {
					borderRadius : '13px'
		  }
			}
	  },
		MuiAccordion : {
			styleOverrides : {
		  root : {
					borderRadius      : '13px',
					'&:first-of-type' : {
			  borderRadius : '13px'
					}
		  }
			}
	  },
	  MuiTextField : {
			styleOverrides : {
				root : {
					borderRadius               : 'var(--pixel8)',
					'& .MuiOutlinedInput-root' : {
			  borderRadius : 'var(--pixel8)'
					},
					'& .MuiOutlinedInput-notchedOutline' : {
						borderColor : 'rgba(0, 0, 0, 0.23)'
					}
		  }
			}
	  },
	  MuiOutlinedInput : {
			styleOverrides : {
		  root : {
					borderRadius : 'var(--pixel8)'
		  },
		  notchedOutline : {
					borderColor : 'rgba(0, 0, 0, 0.23)'
		  }
			}
	  },
	  MuiButton : {
			styleOverrides : {
		  root : {
					borderRadius  : 'var(--pixel8)',
					textTransform : 'capitalize'
		  },
		  containedPrimary : {
					backgroundColor : 'var(--primaryColor)',
					'&:hover'       : {
			  backgroundColor : '#1c8ba4'
					}
		  },
		  containedSecondary : {
					backgroundColor : '#FF9D29',
					'&:hover'       : {
			  backgroundColor : '#e08824'
					}
		  }
			}
	  }
	}
});

theme = createTheme(theme, {
	palette : {
		info : {
			main : theme.palette.secondary.main
		}
	}
});
interface State{
	getSession: () => void,
	socket : any,
	nCount : any,
	loading:boolean,
	call:any,
	setCall:any,
	handleDealfrmNot:any,
	dealTabFrmNotif: any,
	url: any,
	setUrl:any,
	catTab:any,
	setCatTab: any,
	fetchUser : () => void,
	cmpnyImgurl:any,
	setCmpnyImgurl:any,
	callStatusText : any
  }
export const LoginContext = React.createContext<State>({
	getSession       : () => {},
	socket           : {},
	nCount           : 0,
	loading          : true,
	call             : {},
	setCatTab        : () => {},
	catTab           : 0,
	setCall          : () => {},
	handleDealfrmNot : () => {},
	dealTabFrmNotif  : {},
	url            	 : '',
	setUrl           : () => {},
	fetchUser        : () => {},
	cmpnyImgurl    	 : {},
	setCmpnyImgurl   : () => {},
	callStatusText   : ''
});
const socketio = io(`${process.env.REACT_APP_SOCKETURL}`, { autoConnect: false, transports: [ 'websocket' ] });

function App()
{
	const localLanguage = localStorage.getItem('user_language');
	const [ menuItem, setMenuItem ] = useState<any>('');
	const [ localeData, setLocaleData ] = useState(localLanguage || 'en');
	const [ language, setLanguage ] = useState(getObjectWithLanguage(localLanguage || 'en'));
	const langLocalContextVal = useMemo(() => ({ localeData, setLocaleData, language, setLanguage }), [ localeData, setLocaleData, language, setLanguage ]);
	const menuContextVal = useMemo(() => ({ setMenuItem, menuItem }), [ setMenuItem, menuItem ]);
	const [ loading, setLoading ] = useState<boolean>(true);
	const [ socketVal, setSocketVal ] = useState<any>(null);
	const dispatch = useDispatch();
	const session = useSelector((state:any) => state?.mysession?.session);
	const [ hamBurgerVal, setHamBurgerVal ] = useState(false);
	const [ contactHamBurgerVal, setContactHamBurgerVal ] = useState<any>(false);
	const notificationCount = useRef<any>(0);
	const [ isOnline, setIsOnline ] = useState(navigator.onLine);
	const [ call, setCall ] = useState<any>(
		{ status: false, type: null, roomId: null, callBy: null, roomType: '', members: null, senderType: '', callType: '', callFormat: '', roomUsers: null, callStatusText: 'calling' }
	);
	const [ callStream, setCallStream ] = useState<any>(null);
	const [ dealTabFrmNotif, setDealTabFrmNotif ] = useState<any>({
		dealStatus   : '',
		dealSenderId : '',
		dealDetails  : null
	});
	const [ url, setUrl ] = useState<any>('');
	const [ catTab, setCatTab ] = useState(0);
	const [ cmpnyImgurl, setCmpnyImgurl ] = useState<any>({});
	const uploadFile = useSelector((state:any) => state.mymediakit.uploadFile);
	const isLogOutRef = useRef(false);
	const socketInitializedRef = useRef(false);
	const [ showSideNavIcons, setShowSideNavIcons ] = useState<any>(window.location.pathname === '/collaboration');
	const isFullScreenActive = document.fullscreenElement;
	const [ maximizeScreen, setMaximizeScreen ] = useState<any>(isFullScreenActive);
	const { getUserTokenPresence } = useFirebase();
	const addedMsgs = useRef<object[]>([]);
	const callData = useSelector((state:any) => state?.call);
	const peerConnectionRef = useRef<any>(null);
	const remoteStreamRef = useRef();
	const localStreamRef = useRef();
	const reconectionRef = useRef();
	const currentEpisode = useSelector((state:any) => state.audioPlayer.currentEpisode);

	const authListener = (data) =>
	{
		switch (data?.payload?.event)
		{
			case 'signOut':
				isLogOutRef.current = true;
				break;
			case 'signIn':
				isLogOutRef.current = false;
				break;
		}
	};

	useEffect(() =>
	{
		Hub.listen('auth', authListener);
		const handlePopState = () =>
		{
			// console.log('User pressed back!');
			setShowSideNavIcons(false);
		  };

		  window.addEventListener('popstate', handlePopState);

		  return () =>
		{
			window.removeEventListener('popstate', handlePopState);
		  };
	}, []);

	const clearTracks = () =>
	{
		const streamD = callStream;

		streamD?.getTracks().forEach((track) => track.stop());
		setCall({ state: false, type: null, roomId: null, callBy: null, members: null });
		setCallStream(null);
	};

	const chatUnreadData = async (userId:any) =>
	{
		try
		{
			if (userId)
			{
				const readCount = await chatUnreadCount();

				if (readCount.data?.single && readCount.data?.group)
				{
					// dispatch(updatechatUnreadCount({
					// 	total  : readCount.data?.single?.length + readCount.data?.group?.length,
					// 	single : readCount.data.single,
					// 	group  : readCount.data.group
					// }));
					// dispatch(initialChatFetchApi(2));
				}
				if (readCount)
				{
					dispatch(getDealData({ dealConnection: readCount?.dealConnection, dealStatus: readCount?.dealStatus }));
					// dispatch(getNotification(readCount?.unreadCount));
				}
			}
		}
		catch (err:any)
		{
			console.log(err);
		}
	};

	const companyDetails = (companyId) =>
	{
		const query = `?id=${companyId}&type=company`;

		getCompaniesData(query)
			.then((res) =>
			{
				if (res.status)
				{
					dispatch(getCompanyProfileData({ ...res?.data }));
				}
			})
			.catch((err) =>
			{
				console.log(err, 'error');
			});
	};

	const fetchUser = async () =>
	{
		try
		{
			const isLoggedIn = await Auth.currentUserInfo();

			if (!isLoggedIn?.username || isLogOutRef.current) return;
			let res:any = getUserData();

			res = await res;

			let resComapanyData;

			if (res?.data?.companyId)
			{
				const queryForCompanyData = `?type=company&id=${res?.data?.companyId}`;

				 resComapanyData = await getCompaniesData(queryForCompanyData);
			}

			if (res.status && (resComapanyData?.status || res?.data?.role === 'individual'))
			{
				const newObj:any = { ...(res?.data || {}), uuid: generateRandomUUID() };

				dispatch(getUserSession({ ...newObj, companyData: { ...resComapanyData?.data } }));

				// const query = `&uid=${res?.data?.userId}&comid=${res?.data?.companyId}&empRole=${res?.data?.userId?.empRole}&role=${res?.data?.role}`;

				// chatRoomData(query);

				chatUnreadData(res?.data?.userId);
				if (res?.data?.companyId)
				{
					companyDetails(res?.data?.companyId);
				}
			}
		}
		catch (err)
		{
			console.log(err);
		}
	};

	const visiterApi = (userId:string, companyId:string) =>
	{
		const body:any = {
			userId,
			companyId,
			platform : 1
		};

		userVisits(body)
			.then((res:any) =>
			{
				if (res?.status)
				{
					console.log('  ');
				}
			})
			.catch((err:any) =>
			{
				console.log(err);
			});
	};

	const getUserInfo = async () =>
	{
		setLoading(true);

		try
		{
			const payload = await Auth.currentAuthenticatedUser({ bypassCache: true });

			if (Object.keys(payload || {})?.length > 0)
			{
				const userData = processCognitoUserData(payload);

				userData.uuid = generateRandomUUID();
				dispatch(getUserSession(userData));
				setLoading(false);
				userData.role !== 'individual' && visiterApi(userData.userId, userData.companyId || '');
				fetchUser();
			}
			else
			{
				setLoading(false);
			}
		}
		catch (error)
		{
			console.log(error);
			setLoading(false);
		}
	};

	const getBadgeCount = async () =>
	{
		const query = {
			uid     : session?.userId,
			comid   : session?.companyId,
			empRole : session?.empRole,
			role    : session?.role,
			request : 'me',
			type    : 'badge'
		};
		const response = await getConnectionCount(query);

		response?.count?.connectionCount !== undefined && dispatch(updateBadgeCount({ connnectionBadgeCount: response?.count?.connectionCount }));
		response?.count?.contractCount !== undefined && dispatch(updateBadgeCount({ contractBadgeCount: response?.count?.contractCount }));
		response?.count?.followCount !== undefined && dispatch(updateBadgeCount({ followBadgeCount: response?.count?.followCount }));
	};

	const { getCompanyConfigurations, getUserConfigurations, getOtherConfiguration } = useGetConfigs();

	const checkAndEndCall = useCallback(async () =>
	{
		if (call && call?.callBy?.userId === session.userId && call?.callStatus !== 'ongoing')
		{
			socketio?.emit('end_call_before_connect', { roomId: call.roomId });
			clearTracks();
		}
		else if (call && call?.callBy?.userId !== session.userId && call?.callStatus !== 'ongoing')
		{
			socketio?.emit('reject_inc_call', { roomId: call?.roomId });
			setCall({ state: false, type: null, roomId: null, callBy: null, members: null });
		}
		else if (call && call?.callStatus === 'ongoing' && call?.roomType === 'single')
		{
			console.log('conference call in app.js');
			socketio?.emit('conference_call', { type: 'leaveCall' }, { roomId: call?.roomId });
			clearTracks();
		}
		else if (call && call?.callStatus === 'ongoing' && call?.roomType === 'group')
		{
			socketio?.emit('on_leave_call', { roomId: call?.roomId });
			setCall({ state: false, type: null, roomId: null, callBy: null, members: null });
		}
		else
		{
			console.log('none', call);
		}
	}, [ call ]);

	useEffect(() =>
	{
		getUserInfo();
		Hub.listen('auth', authListener);
		const handlePopState = () =>
		{
			setShowSideNavIcons(false);
		};

		window.addEventListener('popstate', handlePopState);

		const handleOnline = () => setIsOnline(true);
		const handleOffline = () => setIsOnline(false);

		window.addEventListener('online', handleOnline);
		window.addEventListener('offline', handleOffline);

		// Initialize persistent storage to protect IndexedDB from eviction
		const initPersistentStorage = async () =>
		{
			try
			{
				// All logging is handled inside requestPersistentStorage()
				await requestPersistentStorage();
			}
			catch (error)
			{
				console.error('Error initializing persistent storage:', error);
			}
		};

		initPersistentStorage();

		return () =>
		{
			window.removeEventListener('popstate', handlePopState);
			window.removeEventListener('online', handleOnline);
			window.removeEventListener('offline', handleOffline);
		};
	}, []);

	const fetchIpAndLocation = async () =>
	{
		try
		{
			const endpoint = process.env.REACT_APP_INMEET_LOCATION;

			if (!endpoint)
			{
				return;
			}

			const response = await fetch(endpoint);
			const data = await response.json();

			console.log('data=============>', data);

			// setIpAddress(data?.ip || '');
			// setLocationInfo({
			// 	latitude  : data?.latitude ?? data?.lat ?? (data?.loc ? Number(data?.loc?.split(',')?.[0]) : null),
			// 	longitude : data?.longitude ?? data?.lon ?? (data?.loc ? Number(data?.loc?.split(',')?.[1]) : null),
			// 	city      : data?.city ?? data?.town ?? '',
			// 	state     : data?.state ?? data?.region ?? '',
			// 	country   : data?.countryCode ?? data?.country ?? '',
			// 	pincode   : data?.pincode ?? data?.postal ?? ''
			// });

			return data;
		}
		catch (error)
		{
			console.error('Error fetching IP/Location:', error);
		}
	};

	const connectToSocket = async () =>
	{
		if (session?.userId)
		{
			const device = deviceInfo();

			const data = await fetchIpAndLocation();
			const locationData = {
				ip        : data?.ip,
				latitude  : data?.latitude ?? data?.lat ?? (data?.loc ? Number(data?.loc?.split(',')?.[0]) : null),
				longitude : data?.longitude ?? data?.lon ?? (data?.loc ? Number(data?.loc?.split(',')?.[1]) : null),
				city      : data?.city ?? data?.town ?? '',
				state     : data?.state ?? data?.region ?? '',
				country   : data?.countryCode ?? data?.country ?? '',
				pincode   : data?.pincode ?? data?.postal ?? ''
			};

			console.log('device=============>', device);
			const sToken = getSocketSessionId();

			try
			{
				socketio.auth =
				{
					userId         : session?.userId,
					name           : session?.firstName,
					masterId       : session?.masterId,
					ipAddress      : data?.ip,
					location       : locationData,
					deviceType     : device?.platform,
					deviceName     : device?.os,
					browserName    : device?.name,
					sessionId      : sToken,
					token          : sToken,
					companyId      : session?.companyId,
					companyName    : session?.companyName,
					profileImage   : session?.profileImage,
					thumbnailImage : session?.thumbnailImage
				};

				// Register error listeners only once
				if (!socketInitializedRef.current)
				{
					socketio.on('connect_error', (err) =>
					{
						console.log('socket connect_error', err?.message || err);
					});

					socketio.on('error', (err) =>
					{
						console.log('socket error', err);
					});

					socketInitializedRef.current = true;
				}

				// Avoid multiple connect calls
				if (!socketio.connected)
				{
					socketio.connect();
					setSocketVal(socketio);
					socketio.emit('user_connected');
				}

				// Ensure we don't accumulate multiple disconnect handlers
				socketio.off('disconnect').on('disconnect', (reason) =>
				{
					console.log('socket disconnected', reason);
				});
			}
			catch (err)
			{
				console.log('Socket Connection Error: ', err);
			}
		}
		else
		{
			socketio.disconnect();
		}
	};

	useEffect(() =>
	{
		connectToSocket();

		const validateUser = async () =>
		{
			if (session?.userId)
			{
				const isMissing = await isInlynkGroupMissing();

				if (isMissing)
				{
					// if missing then need to redirect to signup new
					const payload = await Auth.currentUserInfo();

					dispatch(getUserSession({
						userId    : payload.attributes.sub,
						firstName : payload.attributes['custom:firstName'],
						email     : payload.attributes.email,
						// isActive            : payload.attributes['custom:isActive'],
						uuid      : generateRandomUUID()
					}));
					if (!window.location.pathname.includes('signup'))
					{
						window.location.href = `${window.location.origin}/signup?source=inmeet`;
					}
				}
				// else if ([ 'pending', 'reject', 'deactive' ].includes(session?.isActive) &&
				// !window.location.pathname.includes('emp'))
				// {
				// 	window.location.href = `${window.location.origin}/emp`;
				// }
			}
		};

		validateUser();
		// if (!session?.userId) getUserInfo();
		// else if (Object.keys(session ?? {}).length > 0) checkUserStatus();
	}, [ session?.userId ]);

	useEffect(() =>
	{
		if (session?.userId && Object.keys(session ?? {}).length > 15 && session?.isActive === 'active')
		{
			getUserTokenPresence();

			if(session?.role !== 'individual')
			{
				getBadgeCount();
				getCompanyConfigurations();
				getUserConfigurations();
				getOtherConfiguration(session?.userId);
				dispatch(fetchUncategorizedIdAsync() as any);
			}
		}
		else
		{
			call.status && checkAndEndCall();
		}
		//  calling the useeffect only when all session data is available
	}, [ Object.keys(session ?? {}).length > 15 ]);

	const handleDealfrmNot = (data:any) =>
	{
		setDealTabFrmNotif({
			dealStatus   : data?.status,
			dealSenderId : data?.dealSenderId,
			dealDetails  : data?.dealDetails
		});
	};

	const { updateCallDetails, peerConnectionClose, handleAccept, setupPeerConnection, handleCall, callDbCallBack, handleAudioOff, updateCallCamera, setUpGroupCallInfo } = useCallHelper(peerConnectionRef, remoteStreamRef, localStreamRef, reconectionRef);

	const { messagesDbCallback, handleDeletedData, handleGroupListenerUpdates, handleBroadcastMessages,
		unseenCountUpdate, handleUser,
		getGroupDataFromLocalDb, handleBroadcastListener } = useMessageHook(addedMsgs, peerConnectionRef, remoteStreamRef, localStreamRef, reconectionRef);

	const handleMsgListener = async (response) =>
	{
		dispatch(setGroupIds(response?.groupIds));

		const chatRoomId = store.getState()?.mypresence?.chatRoomInfo?.id;
		const unseenMsgCount = response?.groupIds?.[chatRoomId]?.unseenMsgCount || 0;

		if (unseenMsgCount > 0)
		{
			unseenCountUpdate(store.getState()?.mypresence?.chatRoomInfo, session?.userId);
		}
	};

	const handleIceCandidateUpdate = async (data) =>
	{
		console.log('data==============>', data);
		try
		{
		// Skip processing if the ICE candidate is from the current user
			if (data.fromId === session.userId) return;

			const candidateData = data.candidate;

			// Create a new ICE candidate
			const iceCandidate = new RTCIceCandidate({
				candidate     : candidateData.candidate,
				sdpMid        : candidateData.sdpMid,
				sdpMLineIndex : candidateData.sdpMLineIndex
			});

			// Ensure the peer connection exists and has a valid signaling state
			if (peerConnectionRef.current)
			{
				const signalingState = peerConnectionRef.current.signalingState;

				if (signalingState === 'closed')
				{
					console.warn('connection closed');

					return;
				}

				console.log('iceCandidate==================>', iceCandidate, peerConnectionRef.current);
				if (peerConnectionRef.current.remoteDescription)
				{
					await peerConnectionRef.current.addIceCandidate(iceCandidate);
				}
				else
				{
					console.warn('Remote description is not set');
				}
			}
			else
			{
				console.warn('PeerConnection does not exist');
			}
		}
		catch (error)
		{
			console.error('Failed to handle ICE candidate update:', error);
		}
	};

	const myPresence = useSelector((state:any) => state?.mypresence);
	const isFireBaseAuth = useSelector((state:any) => state?.mypresence?.isFireBaseAuth);

	useEffect(() =>
	{
		let callListener = () => { };
		let unsubscribeSubCollection = () => { };
		const msgListener = () => { };
		const handleuserListener = () => { };

		console.log('peerConnectionRef.current=============>', peerConnectionRef.current);

		  if (store?.getState()?.call.callInprogress && myPresence?.callDetails && myPresence?.callDetails?.callId && Boolean(firebaseDB) && myPresence?.callDetails?.type === PRESENCE_ENUMS.individual)
		{
			callListener = calldbListener('signalling', myPresence?.callDetails?.callId, async (res) =>
			{
				console.log('res===========>', res?.answer, peerConnectionRef.current);
			  if (res?.answer && Object.keys(res?.answer).length > 0 && myPresence?.callDetails?.initiator === session?.userId && peerConnectionRef.current)
				{
					console.log('res?.answerres?.answer', res?.answer);
					peerConnectionRef.current.setRemoteDescription(res?.answer);
			  }
			  // if (res?.offer && Object.keys(res?.offer).length > 0 && callDetails?.initiator !== userInfo.userId && peerConnectionRef.current && !peerConnectionRef?.current.remoteDescription) {
			  //   console.log('haiiiiiiii', peerConnectionRef.current, res?.offer && Object.keys(res?.offer).length > 0 && callDetails?.initiator !== userInfo.userId && peerConnectionRef.current && !peerConnectionRef?.current.remoteDescription)
			  //   peerConnectionRef.current.setRemoteDescription(res?.offer);
			  //   await answerCall();
			  // }
			});

			unsubscribeSubCollection = listenToSubcollectionChanges('signalling', myPresence?.callDetails?.callId, 'candidates', (data) =>
			{
			  console.log('iceCanidatesGettttttt', data);
			  if (data && data.length > 0)
				{
					data.map((candidate) => handleIceCandidateUpdate(candidate));
			  }
			});

			Object.values(myPresence?.callDetails?.participants)?.find((i:any) => i?.id !== session?.userId);
		  }

		return () =>
		{
		  callListener();
		  unsubscribeSubCollection();
		  msgListener();
		  handleuserListener();
		};
	  }, [ store?.getState()?.call.callInprogress ]);

	useEffect(() =>
	{
		if (!session?.userId) return;
		checkAndClearIndexedDBIfUserMismatch(session?.userId);
		// Initialize unsubscribe and userListener as empty functions to clean up listeners later
		let unsubscribe = () => {};
		let userListener = () => {};
		let deletedDataUnsubscribe = () => {};
		let msgUnsubscribe = () => {};
		let unseenMsgListener = () => {};
		let unsubscribeBroadcast = () => {};
		let broadcastMessageListener = () => {};
		let currentUserSettingsListener = () => {};

		// Define a function to set up the listeners asynchronously
		const setupListeners = async () =>
		{
	  if (session?.userId && Boolean(firebaseDB))
			{
			// Check database health before proceeding with sync
				console.log('Checking IndexedDB health before sync...');
				const isDatabaseHealthy = await checkDatabaseHealth();

				if (!isDatabaseHealthy)
				{
					console.warn('Database health check failed. Attempting to reset connection...');
					try
					{
						await resetDatabaseConnection();
						console.log('Database connection reset successfully');
					}
					catch (resetError)
					{
						console.error('Failed to reset database connection. Sync may fail.', resetError);
					// Continue anyway - the individual operations will handle errors
					}
				}

				const statusData = {
					status    : 'online',
					timestamp : Date.now()
		  };

				await updateDeviceData(statusData, session?.userId);

				// User status listener
				userListener = listenToUserStatus(session?.userId, handleUser);

				// Current user settings listener for all user settings
				const handleCurrentUserSettings = (userSettings) =>
				{
					if (userSettings)
					{
						// Store all user data - automatically includes all properties
						dispatch(setCurrentUserSettings({ ...userSettings }));
					}
				};

				currentUserSettingsListener = calldbListener('users', session?.userId, handleCurrentUserSettings);

				await getGroupDataFromLocalDb();

				// 	// Set up Firestore listeners
				unsubscribe = dbListener(
				  'groups',
				  where('members', 'array-contains', session?.userId),
				  orderBy('recentMessageTime', 'desc'),
				  handleGroupListenerUpdates
				);

				unsubscribeBroadcast = dbListener(
				  'broadcasts',
				  where('creatorId', 'in', [ session?.userId ]),
				  orderBy('recentMessageTime', 'desc'),
				  handleBroadcastListener
				);

				// getting messages from local db if chatRoom is present
				if (myPresence?.chatRoomInfo && Object.keys(myPresence?.chatRoomInfo).length > 0)
				{
				  // const prevMessages = await getMessagesFromLocalDb(myPresence?.chatRoomInfo?.id);
				  const prevMessages = (await getMessagesFromLocalDbPagination(myPresence?.chatRoomInfo?.id, 0))?.data;

				  addedMsgs.current = prevMessages || [];

				  dispatch(setChatMessages(addedMsgs.current));
				}

				// Validate and retrieve presence timestamp with safety checks
				let presenceTimestamp: any = null;
				let timestamp: number | null = null;

				try
				{
					const storedTimestamp = localStorage.getItem('presenceTimestamp');

					if (storedTimestamp)
					{
						presenceTimestamp = JSON.parse(storedTimestamp);
						// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
						const parsedTimestamp: number = presenceTimestamp ? parseInt(String(presenceTimestamp)) : NaN;

						// Validate timestamp isn't corrupted, in the future, or too old (more than 30 days)
						const now = Date.now();
						const thirtyDaysAgo = now - (30 * 24 * 60 * 60 * 1000);

						if (isNaN(parsedTimestamp) || parsedTimestamp > now || parsedTimestamp < thirtyDaysAgo)
						{
							console.warn('Invalid presenceTimestamp detected. Clearing and performing full sync.', {
								timestamp : parsedTimestamp,
								now,
								isNaN     : isNaN(parsedTimestamp),
								isFuture  : parsedTimestamp > now,
								isTooOld  : parsedTimestamp < thirtyDaysAgo
							});
							localStorage.removeItem('presenceTimestamp');
							presenceTimestamp = null;
							timestamp = null;
						}
						else
						{
						// @ts-ignore - timestamp is typed as number | null
							timestamp = parsedTimestamp;
						}
					}
				}
				catch (error)
				{
					console.error('Error parsing presenceTimestamp. Clearing and performing full sync.', error);
					localStorage.removeItem('presenceTimestamp');
					presenceTimestamp = null;
					timestamp = null;
				}

				unseenMsgListener = calldbListener('unseenMessages', session?.userId, handleMsgListener);

				if (presenceTimestamp && timestamp)
				{
					console.log('Starting incremental sync from timestamp:', new Date(timestamp).toISOString());
					msgUnsubscribe = MsgDbListener('messages', messagesDbCallback, where('sendTo', 'array-contains', session?.userId), where('updatedAt', '>', timestamp));
					deletedDataUnsubscribe = DeletedMsgDbListener('deletedData', handleDeletedData, where('userId', '==', session?.userId), where('createdAt', '>=', timestamp));
					broadcastMessageListener = MsgDbListener('broadcastMessages', handleBroadcastMessages, where('senderId', '==', session?.userId), where('updatedAt', '>=', timestamp));
				}
				else
				{
					console.log('Starting full sync - no valid timestamp found');
					msgUnsubscribe = MsgDbListener('messages', messagesDbCallback, where('sendTo', 'array-contains', session?.userId));
					deletedDataUnsubscribe = DeletedMsgDbListener('deletedData', handleDeletedData, where('userId', '==', session?.userId));
					broadcastMessageListener = MsgDbListener('broadcastMessages', handleBroadcastMessages, where('senderId', '==', session?.userId));
				}
		  }
		};

		// Call the async setup function

		// if (session?.presenceEnabled && isFireBaseAuth === PRESENCE_ENUMS.connected)
		if (isFireBaseAuth === PRESENCE_ENUMS.connected)
		{
		  setupListeners();
		}

		// Cleanup function to remove listeners and update status when the component unmounts
		return () =>
		{
		  // cleanupCall(); // Any custom cleanup logic for ongoing calls
		  unsubscribe(); // Unsubscribe from group listener
		  userListener(); // Unsubscribe from user status listener
		  currentUserSettingsListener(); // Unsubscribe from current user settings listener
		  msgUnsubscribe();
		  deletedDataUnsubscribe();
		  unseenMsgListener();
		  unsubscribeBroadcast();
		  broadcastMessageListener();
		  // window.removeEventListener('beforeunload', cleanupStatus); // Clean up the event listener
		};

	// Trigger the effect when session.userId or firebaseDB changes
	}, [ session?.userId, firebaseDB, isFireBaseAuth ]);

	if (loading)
	{
		return <GlobalLoader/>;
	}

	return (
		// eslint-disable-next-line max-len
		<ThemeProvider theme={theme}>
			{!isOnline && <ConnectionLost/>}
			<LanguageContext.Provider
				value={
					langLocalContextVal
				}
			>
				<NewsFeedContext.Provider value={menuContextVal}>
					<CallContext.Provider value={{ callStream, setCallStream, clearTracks, isOnline, updateCallDetails, peerConnectionClose, handleAccept, setupPeerConnection, handleCall, callDbCallBack, handleAudioOff, updateCallCamera, setUpGroupCallInfo }}>
						<HamburgerContext.Provider value={{ hamBurgerShow: hamBurgerVal, setHamBurgerShow: setHamBurgerVal, contactHamBurger: contactHamBurgerVal, setContactHamber: setContactHamBurgerVal, showSideNavIcons, setShowSideNavIcons, setMaximizeScreen, maximizeScreen }}>
							<LoginContext.Provider value={{ getSession: getUserInfo, fetchUser, socket: socketVal, nCount: notificationCount, loading, call, setCall, callStatusText: call?.callStatusText, handleDealfrmNot, dealTabFrmNotif, url, setUrl, setCatTab, catTab, cmpnyImgurl, setCmpnyImgurl }}>
								{/* <ChatProvider>
									<div className='baseBlockCntnr'>
										<NavRoutes />
										<ToastContainer
											position='top-right'
											autoClose={5000}
											hideProgressBar={false}
											newestOnTop={false}
											closeOnClick
											rtl={false}
											draggable
											pauseOnHover
											className='toastifyChange'
										/>
									</div>
									{call?.status && call?.roomType === 'single' && <P2PCall />}
									{uploadFile?.length > 0 && <FileUploadBox/>}
									<ChatBox />
								</ChatProvider> */}
								<div className={` ${window.location.pathname === '/collaboration' ? 'overflowClip' : 'scrollY'} baseBlockCntnr`}>
									<NavRoutes />
									<ToastContainer
										position='top-right'
										autoClose={5000}
										hideProgressBar={false}
										newestOnTop={false}
										closeOnClick
										rtl={false}
										draggable
										pauseOnHover
										className='toastifyChange'
									/>
								</div>
								{/* {call?.status && call?.roomType === 'single' && <P2PCall />} */}
								{(callData?.audioCall === PRESENCE_ENUMS.onGoing || callData?.videoCall === PRESENCE_ENUMS.onGoing) &&
									myPresence?.callDetails?.type === PRESENCE_ENUMS.group && <GroupCallPresence closeCall={peerConnectionClose}/>}
								{callData?.audioCall && ([ PRESENCE_ENUMS.incoming, PRESENCE_ENUMS.outGoing, PRESENCE_ENUMS.initiated ]?.includes(callData?.audioCall) || (callData?.audioCall === PRESENCE_ENUMS.onGoing && myPresence?.callDetails?.type !== PRESENCE_ENUMS.group)) && <AudioCalls localStreamRef={localStreamRef.current} remoteStreamRef={remoteStreamRef.current} reconectionRef={reconectionRef.current}/>}
								{callData?.videoCall &&
								 ([ PRESENCE_ENUMS.incoming, PRESENCE_ENUMS.outGoing, PRESENCE_ENUMS.initiated ]?.includes(callData?.videoCall) || (callData?.videoCall === PRESENCE_ENUMS.onGoing && myPresence?.callDetails?.type !== PRESENCE_ENUMS.group)) && <PeerToPeerCall localStreamRef={localStreamRef.current} pc={peerConnectionRef.current} remoteStreamRef={remoteStreamRef.current} reconectionRef={reconectionRef.current}/>}
								{uploadFile?.length > 0 && <FileUploadBox/>}
								{currentEpisode && <AudioPlayer />}
							</LoginContext.Provider>
						</HamburgerContext.Provider>
					</CallContext.Provider>
				</NewsFeedContext.Provider>
			</LanguageContext.Provider>
		</ThemeProvider>
	);
}

export default App;